(function () {
  if (window.ScrollTopRuntimeLoaded) return;
  window.ScrollTopRuntimeLoaded = true;

  const scrollTop = () => {
    const btnScrollTop = document.querySelector(".scroll-top");
    if (!btnScrollTop || btnScrollTop.dataset.scrollTopInitialized === "true") return;

    btnScrollTop.dataset.scrollTopInitialized = "true";

    const updateVisibility = () => {
      if (scrollY > document.documentElement.clientHeight) {
        btnScrollTop.classList.add("show");
      } else {
        btnScrollTop.classList.remove("show");
      }
    };

    window.addEventListener("scroll", updateVisibility, { passive: true });
    btnScrollTop.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    updateVisibility();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scrollTop, { once: true });
  } else {
    scrollTop();
  }

  document.addEventListener("shopify:section:load", scrollTop);
})();
